module.exports = __webpack_public_path__ + "img/id-card-solid.b9c5a08c.svg";